// src/modules/users/services/userService.ts

import { httpClient } from '../../../shared/services/httpClient';
import { API_ENDPOINTS } from '../../../shared/services/apiConfig';
import { ApiResponse } from '../../../types/api';
import { 
  UserProfile, 
  UserDashboard, 
  UpdateProfileData 
} from '../../../types/user';

class UserService {
  /**
   * Obtener perfil completo del usuario autenticado
   */
  async getUserProfile(): Promise<ApiResponse<UserProfile>> {
    try {
      return await httpClient.get<UserProfile>(API_ENDPOINTS.USERS.PROFILE);
    } catch (error: any) {
      return {
        success: false,
        message: error.message || 'Error al obtener perfil del usuario',
        data: null
      };
    }
  }

  /**
   * Actualizar información del perfil
   */
  async updateProfile(data: UpdateProfileData): Promise<ApiResponse<void>> {
    try {
      return await httpClient.put<void>(API_ENDPOINTS.USERS.PROFILE, data);
    } catch (error: any) {
      return {
        success: false,
        message: error.message || 'Error al actualizar perfil',
        data: null
      };
    }
  }

  /**
   * Obtener datos del dashboard
   */
  async getDashboard(): Promise<ApiResponse<UserDashboard>> {
    try {
      return await httpClient.get<UserDashboard>(API_ENDPOINTS.USERS.DASHBOARD);
    } catch (error: any) {
      return {
        success: false,
        message: error.message || 'Error al obtener datos del dashboard',
        data: null
      };
    }
  }
}

export const userService = new UserService();